import React from 'react';
import { SettingDisplay } from 'lib/SettingDisplay';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { PasswordFormField } from 'lib/form/fields/PasswordFormField';
import { IDeliveryProviderSettingsProps } from 'components/settings/DeliverySettings';

export const UberDirectSettingsEdit: React.FC<IDeliveryProviderSettingsProps> = ({ locationId }) => (
    <>
        <SettingDisplay label="Customer ID">
            <TextFormField name="uberDirectCustomerId" />
        </SettingDisplay>
        {locationId === undefined && (
            <>
                <SettingDisplay label="Client ID">
                    <TextFormField name="uberDirectClientId" />
                </SettingDisplay>
                <SettingDisplay label="Client Secret">
                    <PasswordFormField name="uberDirectClientSecret" />
                </SettingDisplay>
                <SettingDisplay label="Webhook Secret">
                    <PasswordFormField name="uberDirectWebhookSecret" />
                </SettingDisplay>
            </>
        )}
    </>
);
